import React from 'react';
import PropTypes from 'prop-types';
//import Link from 'gatsby-link';
//import { css } from 'react-emotion';
import styled from 'react-emotion';
import Triangle from '../icons/css/Triangle';

import { theme } from '../../config/theme';
// import { htmlAdd } from '../util/htmlAdd';

// import Html5YouTube from '../util/html5-youtube';
// import YtScriptLoader from '../util/html5-youtube';

//const init = false;

const BaseDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9997;
  top: 0;
  background-color: black;
`;

// const Iframe = styled.iframe`
//   position: absolute;
//   top: 0;
//   z-index: 0;
//   transition: 0.3s all;
// `;

const Img = styled.img`
  position: fixed;
  top: 0;
  z-index: 98;
  width: 100%;
  height: 100%;
  transition: 0.3s all;
  max-width: 4000%;
  background-color: black;
`;

const Tri = styled(Triangle)`
  transform: rotate(45deg) scale(0.15);
  background-color: ${theme.set.dark.invertWhite};
  top: -4.8rem;
  left: -3.95rem;
  z-index: 99;
  opacity: 0.65;
  transition: ${props => props.theme.transitions.main.duration};
`;
const BgTri = styled(Triangle)`
  transform: rotate(45deg) scale(0.2);
  background-color: ${props => props.theme.set.dark.bgText};
  top: -14.75rem;
  left: -3.95rem;
  z-index: 98;
  opacity: 0.87;
  transition: ${props => props.theme.transitions.main.duration};
`;
const ShadowTri = styled(Triangle)`
  transform: rotate(45deg) scale(0.23);
  background-color: ${props => props.theme.colors.cool.lead};
  top: -24.72rem;
  left: -4rem;
  z-index: 97;
  opacity: 0.55;
  transition: ${props => props.theme.transitions.main.duration};
`;
const TriDiv = styled.div`
  z-index: 99;
  position: fixed;
  left: 50%;
  top: 50%;
  @media (min-width: 1920px) {
    left: 30%;
    top: 30%;
  }
`;

const Clicker = styled.div`
  width: 100%;
  position: fixed;

  &:focus,
  &:hover {
    cursor: pointer;
    ${Img} {
      width: 112%;
      height: 112%;
      margin-left: -6%;
      margin-top: -6%;
    }
    ${Tri} {
      background-color: ${props => props.theme.colors.warm.fade};
      opacity: 1;
    }
    ${BgTri} {
      opacity: 1;
    }
    ${ShadowTri} {
      opacity: 0.65;
    }
  }
`;

let id = '';
let vid = '';
let img = '';
let b1x1 = '';
let clicked = false;
// 11 chars per (12 with separator).

const fixImg = imgId => {
  document.getElementById(imgId).src = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
};

// const load = () => {
//   //document.getElementById('HeadroomWrapDiv').style.display = 'none';
//   document.getElementById(`baseDiv_${id}`).style.background = 'transparent';
// };

const handleSubmit = e => {
  if (!clicked) {
    document.getElementById(`img_${id}`).style.display = 'none';
    document.getElementById(`playMedia_${id}`).style.display = 'none';
    if (typeof window !== 'undefined') {  
      //window.location = `${vid}controls=1;loop=1;showinfo=0;modestbranding=1;disablekb=1;enablejsapi=1;html5=1;playlist=${id};`;
      //window.location = `${vid}loop=1;`;
      //window.location = `${vid}?enablejsapi=1;autoplay=1;loop=1;controls=1;showinfo=0;modestbranding=1;disablekb=1;`;
      window.location = `${vid}?autoplay=1;&mute=1;enablejsapi=1;controls=1;showinfo=0;modestbranding=1;disablekb=1;`;

      console.log(`${vid}`);
    }
    clicked = true;
  }
};

const Vid = ({ type }) => {
  if (typeof window !== 'undefined') {
   // if (window.location.pathname.length === 27) {
      //id = window.location.pathname.substring(16, window.location.pathname.length);
    id = window.location.hash.substring(1, window.location.hash.length);
    img = window.location.hostname;
    //vid = `//www.youtube-nocookie.com/embed/${id}?autoplay=1;enablejsapi=1;html5=1;`;
    //vid = `https://youtube.com/embed/${id}?autoplay=1;enablejsapi=1;html5=1;`;
    vid = `https://www.youtube-nocookie.com/embed/${id}`;

    // alert(window.location.pathname);
  }
  if (img.match('localhost')) {
    img = `${img}:8000`;
  }

  b1x1 = `//${img}/img/iframe/`;

  //img = `${b1x1}/${id}.jpg`;
  img = `${b1x1}/${id}.webp`;

  b1x1 = `${b1x1}1b.gif`;


  // alert(`id:${id} | vid:${vid}`);

  // const baseDivClass = '';
  // className={css(baseDivClass)}
    return (
    <React.Fragment>
      <Clicker id={`clicker_${id}`} onClick={e => handleSubmit(e)} rel="noopener noreferrer">
          <TriDiv id={`playMedia_${id}`}>
            <Tri />
            <BgTri />
            <ShadowTri />
          </TriDiv>
          <Img id={`img_${id}`} src={img} onError={e => fixImg(`img_${id}`)} />
      </Clicker>
    </React.Fragment>
  );
  /*
      return (
    <React.Fragment>
      <Clicker id={`clicker_${id}`} onClick={e => handleSubmit(e)}>
        <BaseDiv id={`baseDiv_${id}`}>
          <TriDiv id={`playMedia_${id}`}>
            <Tri />
            <BgTri />
            <ShadowTri />
          </TriDiv>
          <Img id={`img_${id}`} src={img} onError={e => fixImg(`img_${id}`)} />
        </BaseDiv>
      </Clicker>
    </React.Fragment>
  );
  
  return (
    <React.Fragment>
      <Img id={`b1x1_${id}`} src={b1x1} style={{ opacity: `0`, zIndex: `0` }} onLoad={e => preload()} />
      <Clicker id={`clicker_${id}`} onClick={e => handleSubmit(e)}>
        <BaseDiv id={`baseDiv_${id}`}>
          <TriDiv id={`playMedia_${id}`}>
            <Tri />
            <BgTri />
            <ShadowTri />
          </TriDiv>
          <Img id={`img_${id}`} src={img} onError={e => fixImg(`img_${id}`)} onLoad={e => load()} />
          <Iframe
            id={`iframe_${id}z`}
            width="100%"
            height="100%"
            scrolling="no"
            muted
            allow="autoplay"
            autoplay="yes"
            frameBorder="0"
            allowFullScreen
          />
        </BaseDiv>
      </Clicker>
    </React.Fragment>
  );
  */
};

export default React.memo(Vid);

Vid.propTypes = {
  type: PropTypes.string,
};

Vid.defaultProps = {
  type: '',
};



// WEBPACK FOOTER //
// ./src/pages/vid.jsx